import React from 'react'
import './Custom_design.css'

const Custom_design = () => {
    const customdata = [
        {
            image: '/assets/images/enggagement/custom-design/ringpng01.png',
            title: 'Share Your Vision',
            content: 'Your concepts and photos are used to develop the design',
        },
        {
            image: '/assets/images/enggagement/custom-design/ringpng02.avif',
            title: 'Design & Consultation',
            content: 'We conceptualize your design,provide a rendering',
        },
        {
            image: '/assets/images/enggagement/custom-design/ringpng03.avif',
            title: 'Made to order',
            content: 'Your design becomes a reality as your vision comes to life',
        }


    ];
    return (
        <>
            <section className='Custom_designsec'>
                <div className='container p-0'>
                    <h5 className='customtitle'>The Custom Design Process </h5>
                    <div className='row mt-4'>
                        {customdata.map((data, index) => (
                            <div className='col-lg-4 col-sm-6 col-12 mx-auto mb-4'>
                                <div className='customdiv'>
                                    <img className='customimg' src={data.image} alt="custom-design" />
                                    <h6 className='customh6'>{data.title}</h6>
                                    <p className='customp'>{data.content}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </section>
        </>
    )
}

export default Custom_design